import { render } from "./Tiles.vue?vue&type=template&id=93c7bede&ts=true"
import script from "./Tiles.vue?vue&type=script&lang=ts"
export * from "./Tiles.vue?vue&type=script&lang=ts"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__